import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Button, Modal, ModalBody } from "reactstrap";
import { OroLoaderInline } from "../../core";

export default function FailPopUpRfq(props) {
    const {
        openRfqFailedPopUp,
        toggleRfqFailedPopUp,
    } = props;

    const bankDetails = {
        border: "0.8px solid #979797",
        borderRadius: '5px',
        padding: '17px 0 17px 21px',
        position: 'relative'
    }

    const label = {
        position: "absolute",
        fontSize: "13px",
        color: "#575757",
        fontWeight: "600",
        background: "#FFF",
        top: "-0.65rem",
        padding: "0 0.5rem",
        marginLeft: "-0.5rem"
    }

    return (
        <Modal
            isOpen={openRfqFailedPopUp}
            zIndex={9999}
            centered
            className="rfq-modal"
        >
            <ModalBody>
                <>
                    <div style={{ textAlign: "center", alignItems: "center" }}>
                        <img className="text-center mt-2" src={process.env.REACT_APP_IMAGES_PATH + "rfqFailImg.webp"} style={{ width: "45px", height: "43px" }} />
                    </div>
                    <div className="p-4">
                        <div className="d-flex flex-column">
                            <div style={{ textAlign: "center" }}>
                                <p style={{ color: "#FD1919", fontWeight: "600", fontSize: "20px" }}>
                                    Order Status Update
                                </p>
                            </div>


                            <ul className="p-1">
                                <li className="font-size-12 text-left">Your order has been confirmed on the exchange. However the UPI/Netbanking payment link couldn't be generated due to technical issue at exchange.</li>
                                <li className="font-size-12 text-left">We request you to proceed with NEFT/RTGS mode to complete the payment.</li>
                            </ul>
                            <p className="font-size-12 text-left">Kindly ensure that the payment is done to avoid suspension of your account from Debt market for a period of 15 days as per SEBI Regulation.</p>
                            {/* <Button
                                color="secondary"
                                outline
                                className="font-weight-semi-bold font-size-16 mt-3 ml-auto mr-auto w-100"
                                style={{ borderRadius: '10px', border: "none", minHeight: "52px" }}
                                onClick={toggleRfqFailedPopUp}>
                                Proceed with NEFT/RTGS
                            </Button> */}
                            <Button
                                style={{ borderRadius: '10px', border: "none", minHeight: "52px" }}
                                onClick={toggleRfqFailedPopUp}>
                                Proceed with NEFT/RTGS
                            </Button>

                        </div>
                    </div>
                </>
            </ModalBody>
        </Modal>
    );
}
